<template>
  <div class="slideSearchBarBox" @mouseover="show=true" @mouseleave="mouseleave">
    <el-button icon="el-icon-search" style="font-size:18px;margin-top:-3.5px" type="text" @click="handelSearch">
    </el-button>
      <div class="slideSearchBar">
        <transition name="slideRight">
          <div v-show="show">
            <slot name="searchBar" ref="searchBar"></slot>
          </div>          
        </transition>
      </div>    
  </div>
</template>
<script>
export default {
  name: 'slideSearchBar',
  data() {
    return {
      show: false,
      inputVal: undefined
    }
  },
  activated() {
    this.show = false
  },
  methods: {
    handelSearch() {
      this.$emit('handelSearch', this.$slots.searchBar[0].child._props.value)
    },
    mouseleave() {
      const val = this.$slots.searchBar[0].child._props.value
      this.show = !!val.length
    }
  }
}
</script>
<style lang="scss">
  .slideSearchBarBox{
    position: relative;
    .slideSearchBar{
      height:35px;
      position: absolute;
      right: 0px;
      top:50%;
      margin-top: -16px;
      width: calc(100%);
      overflow: hidden;
      .el-input .el-input__inner{
        border-top: none;
        border-left: none;
        border-right: none;
        border-radius: 0;
      }
      .el-input-group__append{
        background: #fff !important;
        border:none;
        padding:0 5px;
      }
    }
  }
</style>


